import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
`;

export const Header = styled.div`
  padding: 1rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors?.gray02};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const SearchWrapper = styled.div`
  position: relative;
  padding: 0.75rem 1rem;
  gap: 0.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors?.gray02};
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 1.75rem;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.colors?.text?.secondary};
  display: flex;
  align-items: center;
  pointer-events: none;
`;

export const SearchInput = styled.input<{ $hasClearButton?: boolean }>`
  width: 100%;
  padding: 0.5rem ${({ $hasClearButton }) => ($hasClearButton ? '2.5rem' : '2.5rem')} 0.5rem 2.5rem;
  border: 1px solid ${({ theme }) => theme.colors?.gray02};
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors?.backgroundColor};
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: ${({ theme }) => theme.colors?.primary};
  }

  &::placeholder {
    color: ${({ theme }) => theme.colors?.text?.secondary};
  }
`;

export const ClearButtonWrapper = styled.div`
  position: absolute;
  right: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
`;

export const ClearButton = styled.button`
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.25rem;
  border-radius: 50%;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors?.gray01};
    color: ${({ theme }) => theme.colors?.text?.primary};
  }
`;

export const Title = styled.h3`
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs18};
  margin: 0;
`;

export const NewChatButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  background-color: ${({ theme }) => theme.colors?.primary};
  color: ${({ theme }) => theme.colors?.white01};
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const NewChatButtonText = styled.span`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const Section = styled.div`
  margin-bottom: 1rem;
`;

export const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const SectionTitleText = styled.span``;

export const SubSection = styled.div`
  margin-bottom: 0.5rem;
`;

export const SubSectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem 0.5rem 2rem;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs10};
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.8;
`;

export const List = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const ConversationItem = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors?.gray02};
  background-color: ${({ selected, theme }) =>
    selected ? theme.colors?.gray01 : 'transparent'};
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ theme }) => theme.colors?.gray01};
  }
`;

export const AvatarContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`;

export const AvatarPlaceholder = styled.div<{ $isGroup?: boolean; $isFavorited?: boolean }>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: ${({ $isGroup, $isFavorited, theme }) => {
    if ($isFavorited) {
      return theme.colors?.warning || theme.colors?.secondary;
    }
    if ($isGroup) {
      return theme.colors?.aqua || theme.colors?.primary;
    }
    return theme.colors?.secondary || theme.colors?.primary;
  }};
  color: ${({ theme }) => theme.colors?.white01};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs16};
`;

export const OnlineIndicator = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors?.success};
  border: 2px solid ${({ theme }) => theme.colors?.backgroundColor};
`;

export const OfflineIndicator = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors?.danger};
  border: 2px solid ${({ theme }) => theme.colors?.backgroundColor};
`;

export const ConversationContent = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
`;

export const ConversationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.25rem;
`;

export const ConversationName = styled.div`
  font-weight: 600;
  color: ${({ theme }) => theme.colors?.text?.primary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Timestamp = styled.span`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  color: ${({ theme }) => theme.colors?.text?.secondary};
  flex-shrink: 0;
`;

export const LastMessage = styled.div`
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs10};
  color: ${({ theme }) => theme.colors?.text?.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const UnreadBadge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors?.primary};
  color: ${({ theme }) => theme.colors?.white01};
  border-radius: 10px;
  padding: 0.15rem 0.5rem;
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs12};
  font-weight: 600;
  min-width: 20px;
  text-align: center;
`;

export const EmptyState = styled.div`
  padding: 2rem;
  text-align: center;
  color: ${({ theme }) => theme.colors?.text?.secondary};
  font-size: ${({ theme }) => theme.fontSize?.[theme.fontSizeType]?.fs14};
`;

